import { useQuery } from "urql";

import {
  DateRangeFilterInput,
  GetInvoicesDocument,
  InvoiceFilter,
  InvoiceOrderBy,
} from "../../../graphql/generated.ts";
import { getApiPaginationData } from "../../../utils/api.ts";
import { ApiHookProps } from "../types.ts";

interface Props extends ApiHookProps<InvoiceFilter, InvoiceOrderBy> {
  lastPaymentDate?: DateRangeFilterInput;
}

export const useInvoices = ({
  filter,
  orderBy,
  pause,
  page,
  lastPaymentDate,
}: Props) => {
  const pagination = getApiPaginationData(page);
  const variables = {
    filter,
    orderBy,
    skip: pagination?.skip,
    take: pagination?.take,
    lastPaymentDate,
  };
  return useQuery({ query: GetInvoicesDocument, variables, pause });
};
